export default __webpack_public_path__ + "images/67d78e3b06cc4a04ed4d7f7071885ae0-Subtitle.jpg";